module.exports = window.top != window || document.body.classList.contains("embedded");